<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
        <el-button v-if="total < 6" type="primary" size="mini" @click="
            search.chooseOrgVisible = true;
            searchData();
          "> 添加 </el-button>
      </el-col>
    </el-row>
    

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column
          prop="object_id"
          label="对象ID"
          align="center"
          min-width="3%"
        ></el-table-column>
        <el-table-column label="标题" align="center" min-width="25%" prop="title">
        </el-table-column>
        <el-table-column label="图片" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button type="danger" size="small" @click="del(row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <el-dialog
      title="选择"
      :visible.sync="search.chooseOrgVisible"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
            size="small"
            v-model="search.query.search"
            placeholder="请输入标题"
            clearable
            @blur="searchData()"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="
              searchData();
            "
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <el-tabs v-if="query.target_type == 'course'" v-model="search.activeName" @tab-click="handleClick">
        <el-tab-pane label="普通课程" name="1"></el-tab-pane>
        <el-tab-pane label="线下课" name="5"></el-tab-pane>
      </el-tabs>

      <!--列表-->
      <el-table
        border
        :data="search.result.data"
        highlight-current-row
        v-loading="search.listLoading1"
        style="..."
      >
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="selectProduct(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="searchData"
        :current-page.sync="search.query.page"
        :page-size="search.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="search.result.total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import {
  screenProductList,
} from "@/api/coupon";

import {
  getList,
  add,
  del,
} from "@/api/recommend";

import {
  getList as getArticleList
} from "@/api/article";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        target_id: this.$route.query.target_id,
        target_type: this.$route.query.target_type,
        object_type: this.$route.query.target_type,
        page: 1,
        limit: 20,
      },

      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        activeName: "1",
        query: {
          type: 1,
          search: "",
          page: 1,
          limit: 5,
          target_type: 1,
        },
        result: {
          total: 0,
          data: [],
        },
      },

      addData: {
        target_id: this.$route.query.target_id,
        target_type: this.$route.query.target_type,
        object_type: this.$route.query.target_type,
        object_id: 0,
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    handleClick(tab, event) {
      this.search.query.target_type = Number(tab.name);
      this.searchData();
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.activeName = "1";
      this.search.query.type = 1;
      this.search.query.search = "";
      this.search.query.target_type = 1;

      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
      
    },
    // 查询方法
    searchData() {
      this.search.listLoading1 = true;
      if (this.query.target_type == 'course') {
        screenProductList(this.search.query).then((response) => {
          this.search.result.data = response.data.list;
          this.search.result.total = response.data.total;
          this.search.listLoading1 = false;
        });
      } else {
        this.search.query.title = this.search.query.search;
        this.search.query.type = 'app';
        this.search.query.status = 1;
        getArticleList(this.search.query).then((response) => {
          this.search.result.data = response.data.list;
          this.search.result.total = response.data.total;
          this.search.listLoading1 = false;
        });
      }  
    },
    selectProduct(row) {
      this.addData.object_id = row.id;

      add(this.addData)
        .then((response) => {
          this.updateLoading = false;
          if (response.status == 2000) {
            this.$message.success(response.message);
            this.getList();
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });

      this.search.chooseOrgVisible = false;
    },


    getList() {
      this.loading = true;
      getList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    del(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        del({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
  mounted() {},
};
</script>